export const getHexColor = (hexColor?: string): string | undefined => {
	if (hexColor) {
		let hexColor6Digits = hexColor;
		while (hexColor6Digits.length < 6) {
			hexColor6Digits = '0' + hexColor6Digits;
		}

		return `#${hexColor6Digits}`;
	}

	return undefined;
};
